import React, { useRef } from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

// import config
import { GRAPHQL_API_URL } from '../../util/config';

// import hooks
import { useGraphqlFetch } from '../../hooks';

// import components
import ReviewItem from './ReviewItem';

// import styled components
import { Grid } from '../styled';
import {
  ReviewsCarouselWrapper,
  ReviewsControlsMobile,
  ReviewsItemsWrapper,
  ReviewsTitleWrapper,
} from './styled';

// import svg
import ControlLeft from '../../svgs/control-left.svg';
import ControlRight from '../../svgs/control-right.svg';
import QuoteLeft from '../../svgs/quote-left.svg';
import QuoteRight from '../../svgs/quote-right.svg';

const Reviews = () => {
  const aliceRef = useRef(null);
  const reviewsQuery = `
  {
  reviewsList {
    reviews {
      id
      name
      comment
      date
      rating
      locationName
    }
  }
  }`;

  const [data, error, loading] = useGraphqlFetch(
    GRAPHQL_API_URL,
    reviewsQuery,
    false
  );

  const createReviewItems = data => {
    console.log(data);
    const filteredReviewItems = data.reviewsList.reviews.filter(
      item =>
        item.comment &&
        item.comment.length > 0 &&
        item.rating > 4 &&
        !item.comment.includes('Tabor') &&
        !item.comment.includes('FX')
    );
    const trimmedReviewItems = filteredReviewItems.slice(0, 10);

    return trimmedReviewItems.map(item => (
      <ReviewItem
        key={item.id}
        comment={item.comment}
        date={item.date}
        rating={item.rating}
        name={item.name}
        // url={item.url}
        QuoteLeft={QuoteLeft}
        QuoteRight={QuoteRight}
      />
    ));
  };

  const drawReviews = (data, error, loading) => {
    if (loading) return <h1>Loading...</h1>;

    if (error) return <h1>{`Error!: ${error}`}</h1>;

    const responsive = {
      0: { items: 1 },
      767: { items: 2 },
      991: { items: 3 },
    };

    const reviewItems = createReviewItems(data);

    return (
      <ReviewsCarouselWrapper>
        <span
          className="control left"
          onClick={() => aliceRef.current.slidePrev()}
        >
          <ControlLeft />
        </span>
        <AliceCarousel
          ref={aliceRef}
          items={reviewItems}
          responsive={responsive}
          dotsDisabled={true}
          buttonsDisabled={true}
        />
        <span
          className="control right"
          onClick={() => aliceRef.current.slideNext()}
        >
          <ControlRight />
        </span>
      </ReviewsCarouselWrapper>
    );
  };

  return (
    <section aria-label="Reviews">
      <ReviewsTitleWrapper>
        <Grid noPadding={true}>
          <h1>What our clients say about us</h1>
        </Grid>
      </ReviewsTitleWrapper>
      <ReviewsItemsWrapper>
        {drawReviews(data, error, loading)}
        <ReviewsControlsMobile>
          <ControlLeft onClick={() => aliceRef.current.slidePrev()} />
          <ControlRight onClick={() => aliceRef.current.slideNext()} />
        </ReviewsControlsMobile>
      </ReviewsItemsWrapper>
    </section>
  );
};

export default Reviews;
